module.exports = __webpack_public_path__ + "static/media/logo-chrome-color.80165ca5.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo-chrome-color.svg
 ** module id = 273
 ** module chunks = 0
 **/